<template>
  <div class="textMain" id="field" :style="{
    'width': '100%',
    'height': '100%',
    'position': 'relative',
    'border': (properties['border'] ? 'solid 1px gray' : ''),}">

    <div class="textDisplay" ref="textDisplay" v-html="formattedText(properties['value'])" :style="{
      'width': '100%',
      'height': 'auto',
      'line-height': (((Math.floor(((properties['fontSize'] * zoomLevel) * fontPtPx) * 10) / 10) + 2) + 'px'),
      'font-size': ((Math.floor(((properties['fontSize'] * zoomLevel) * fontPtPx) * 10) / 10) + 'px'),
      'font-family': properties['fontFamily'],
      'font-weight': properties['fontWeight'],
      'text-align': properties['fontJustify'],
      'position': 'absolute',
      'top': '0px',
      'bottom': '0px',
      'pointer-events': 'none',
      'word-wrap': 'break-word',
      'white-space': 'pre-wrap',
      'z-index': '10',
      'overflow-x': (textAreaFocus ? 'hidden' : (properties['fontOverflow'] ? 'visible' : 'hidden')),
      'overflow-y': (properties['fontOverflow'] ? 'visible' : 'hidden')}"></div>

    <textarea class="textArea" id="field" ref="textArea" v-model="properties['value']" spellcheck="false" :style="{
      'pointer-events': ((properties['focus'] && properties['selected']) ? 'all' : 'none'),
      'line-height': (((Math.floor(((properties['fontSize'] * zoomLevel) * fontPtPx) * 10) / 10) + 2) + 'px'),
      'font-size': ((Math.floor(((properties['fontSize'] * zoomLevel) * fontPtPx) * 10) / 10) + 'px'),
      'font-family': properties['fontFamily'],
      'font-weight': properties['fontWeight'],
      'text-align': properties['fontJustify'],
      'word-wrap': properties['fontOverflow'] ? 'break-word' : '',
      'overflow-y': (textAreaFocus ? '' : 'hidden'),
      'user-select': (textAreaFocus ? '' : 'none'),
      'opacity': (textAreaFocus ? '' : '0')}"
      
      @keydown="textAreaBtn('keyDown', '', $event)"
      @scroll="textAreaBtn('scroll', '', $event)"
      @input="textAreaBtn('scroll', '', $event)"
      @focus="textAreaBtn('focus', true, $event)"
      @blur="textAreaBtn('focus', false, $event)"></textarea>

      <div class="editorMain" v-if="properties['selected'] && !print" :style="{'left': (((((data['posX2'] - data['posX1']) * zoomLevel) / 2) - 100) + 'px')}">
        <div class="row">
          <div class="column" :style="{'flex': '1'}">
            <select :style="{'width': '100%'}" v-model="properties['fontFamily']">
              <option v-for="(f, i) in fonts" :key="'font' + i" :value="f">{{f.replace(/\'/g, '')}}</option>
            </select>
            <input type="number" v-model="properties['fontSize']" min="1" :style="{'width': '50px', 'margin': '0 0 0 5px'}"/>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <button :class="[(properties['fontJustify'] == 'left') ? 'selected' : '']" title="Justify Left"
              @click="editorBtn('justify', 'left')"><svg viewBox="0 0 500 500"><path :d="icon['justifyL']"/></svg></button>
            <button :class="[(properties['fontJustify'] == 'center') ? 'selected' : '']" title="Justify Center"
              @click="editorBtn('justify', 'center')"><svg viewBox="0 0 500 500"><path :d="icon['justifyC']"/></svg></button>
            <button :class="[(properties['fontJustify'] == 'right') ? 'selected' : '']" title="Justify Right"
              @click="editorBtn('justify', 'right')"><svg viewBox="0 0 500 500"><path :d="icon['justifyR']"/></svg></button>
          </div>
          <div class="column">
            <button :class="[(properties['fontWeight'] == 'bold') ? 'selected' : '']" title="Bold" :style="{'margin': '0 0 0 0', 'font-size': '16px', 'font-weight': 'bold', 'color': 'white'}"
              @click="editorBtn('bold', '')">B</button>
            <button :class="[properties['border'] ? 'selected' : '']" title="Border"
              @click="editorBtn('border', '')"><svg viewBox="0 0 500 500"><path :d="icon['border']"/></svg></button>
            <button :class="[properties['fontOverflow'] ? 'selected' : '']" title="Overflow"
              @click="editorBtn('wrap', '')"><svg viewBox="0 0 500 500"><path :d="icon['overflow']"/></svg></button>
          </div>
        </div>
      </div>

      <!-- Sub Editor HTMl -->
      <div class="subEditorMain" v-if="properties['selected'] && !print">
        <button :class="[properties['border'] ? 'selected' : '']" title="Border"
          @click="editorBtn('border', '')"><svg viewBox="0 0 500 500"><path :d="icon['border']"/></svg></button>
        <!-- <button title="Copy"
          @click="editorBtn('wrap', '')"><svg viewBox="0 0 500 500"><path :d="icon['copy']"/></svg></button> -->
      </div>
  </div>
</template>

<script>
  /* eslint-disable */
  
  
  export default {
    name: 'designerText',
    components: {
      
    },
    props: {
      data: { type: Object, default: function() { return {}; }},
      printData: { type: Object, default: function() { return {}; }},

      properties: { type: Object, default: function() { return {}; }},
      zoomLevel: { type: Number, default: 1 },
      fontPtPx: { type: Number, default: 1 },
      print: { type: Boolean, default: false },
    },
    data() { 
      return {
        //-- Text Data
        textAreaFocus: false,

        //-- Referenced Default data
        fonts: [
          'Arial, sans-serif',
          'Verdana, sans-serif',
          'Tahoma, sans-serif',
          '\'Trebuchet MS\', sans-serif',
          '\'Times New Roman\', serif',
          'Georgia, serif',
          'Garamond, serif',
          '\'Courier New\', monospace',
          '\'Brush Script MT\', cursive',
        ],
        icon: {
          'alignT': 'M50 195L50 190L450 190L450 195L50 195ZM50 125L50 120L450 120L450 125L50 125ZM50 55L50 50L450 50L450 55L50 55Z',
          'alignC': 'M50 322.5L50 317.5L450 317.5L450 322.5L50 322.5ZM50 252.5L50 247.5L450 247.5L450 252.5L50 252.5ZM50 182.5L50 177.5L450 177.5L450 182.5L50 182.5Z',
          'alignB': 'M50 450L50 445L450 445L450 450L50 450ZM50 380L50 375L450 375L450 380L50 380ZM50 310L50 305L450 305L450 310L50 310Z',
            
          'justifyL': 'M50 250L450 250L450 270L50 270L50 250Z M50 130L230 130L230 150L50 150L50 130Z M50 370L330 370L330 390L50 390L50 370Z',
          'justifyC': 'M50 250L450 250L450 270L50 270L50 250Z M50 130L450 130L450 150L50 150L50 130Z M50 370L450 370L450 390L50 390L50 370Z',
          'justifyR': 'M50 250L450 250L450 270L50 270L50 250Z M270 130L450 130L450 150L270 150L270 130Z M170 370L450 370L450 390L170 390L170 370Z',
      
          'border': 'M240 450L240 440L320 440L320 450L240 450ZM60 60L60 450L50 450L50 50L450 50L450 60L60 60ZM110 450L110 440L190 440L190 450L110 450ZM370 450L370 440L440 440L440 368.1L450 368.1L450 450L370 450ZM440 320L440 240L450 240L450 320L440 320ZM440 190L440 110L450 110L450 190L440 190Z',
          'overflow': 'M405 100L400 100L400 55L55 55L55 400L100 400L100 405L50 405L50 50L405 50L405 100ZM150 355L150 350L450 350L450 355L150 355ZM150 260L150 255L450 255L450 260L150 260ZM150 165L150 160L450 160L450 165L150 165Z',
          'copy': 'M50 107.14L392.86 107.14L392.86 450L50 450L50 107.14Z M450 392.86L450 50L107.14 50 M50 107.14L392.86 107.14L392.86 450L50 450L50 107.14Z',
        }
      }
    },
    computed: {
      getFocusState() {
        return this.properties['focus'];
      },
      getSelectedState() {
        return this.properties['selected'];
      },
    },
    mounted() {
      // console.log(this.properties['value']);
      // console.log(this.properties['focus']);
      // this.$set(this.data, 'focus', true);
    },
    beforeDestroy() {
      
    },
    methods: {
      formattedText(text) {
        if (text) {
          if (this.textAreaFocus) {
            return text ? text : '';
          } else {
            //---- Set variables
            var text = JSON.parse(JSON.stringify(text));
            var match = [];
            var pattern = /{([^}]*)}/g;

            //---- Get keys found in text
            var textKeys = [];
            while (match = pattern.exec(text)) { textKeys.push(match[0]); }

            //-- Format each key into a displayed item
            textKeys.forEach((k, i) => {
              var textFormattedKey = '';
              if (this.print) {
                if (this.printData) {
                  textFormattedKey = this.printData[k.replace(/\{|\}/g, '')] ? this.printData[k.replace(/\{|\}/g, '')] : '';
                  // console.log(textFormattedKey);
                }
              } else {
                textFormattedKey = '<span style="' + 
                'width: auto;' + 
                'height:' + (((Math.floor(((this.properties['fontSize'] * this.zoomLevel) *this. fontPtPx) * 10) / 10) + 2) + 'px;') + 
                'padding: 0 5px;' + 
                'font-size:' + ((Math.floor(((this.properties['fontSize'] * this.zoomLevel) *this. fontPtPx) * 10) / 10) + 'px;') + 
                'display: inline-block;' + 
                'background-color: #0002;' + 
                'border: solid 1px gray;' + 
                'border-radius: 20px;' + 
                '">' + k.replace(/\{|\}/g, '') + '</span>';
              
              } 
              

              text = text.replace(k, textFormattedKey);
            });

            return text;
          }
        } else { return ''; }
      },
      textAreaBtn: async function(cmd, data, e) {
        switch(cmd) {
          case 'keyDown':
            switch(e['key']) {
              case 'Tab':
                e.preventDefault();

                var textAreaDOM = this.$refs['textArea'];

                //-- Get current selection position
                var selStart = textAreaDOM['selectionStart'];
                var selEnd = textAreaDOM['selectionEnd'];

                if (selStart == selEnd) {
                  
                  var newValue = this.properties['value'].substring(0, selStart) + '    ' + this.properties['value'].substring(selStart, this.properties['value']['length']);
                  this.$set(this.properties, 'value', newValue);

                  this.$nextTick(() => {
                    textAreaDOM['selectionStart'] = selStart + 4;
                    textAreaDOM['selectionEnd'] = selStart + 4;
                  });
                }
                break;
              case 'A':
              case 'a':
                if (e['ctrlKey']) {
                  e.preventDefault(); 
                  var textAreaDOM = this.$refs['textArea'];

                  textAreaDOM['selectionStart'] = 0;
                  textAreaDOM['selectionEnd'] = this.properties['value']['length'];
                }
                break;
            }
            break;
          case 'focus':
            var textAreaDOM = this.$refs['textArea'];
            var textDisplayDOM = this.$refs['textDisplay'];
            this.textAreaFocus = data;
            this.$set(this.properties, 'focus', data);
            if (data) {
              this.$refs['textArea'].focus();

              this.$nextTick(() => {
                //-- Set scroll to edit area
                textDisplayDOM.scrollTo(textAreaDOM['scrollLeft'], textAreaDOM['scrollTop']);

                //-- Set cursor to end
                textAreaDOM['selectionStart'] = this.properties['value']['length'];
                textAreaDOM['selectionEnd'] = this.properties['value']['length'];
              });
            } else {
              this.$refs['textArea'].blur();


              this.$nextTick(() => {
                //-- Set scroll to top
                textDisplayDOM.scrollTo(0, 0);
              });
            }
            break;
          case 'scroll':
            //-- Set variables
            var textAreaDOM = this.$refs['textArea'];
            var textDisplayDOM = this.$refs['textDisplay'];

            textDisplayDOM.scrollTo(textAreaDOM['scrollLeft'], textAreaDOM['scrollTop']);
            break;
        }
      },
      editorBtn: async function(cmd, data) {
        switch(cmd) {
          case 'justify':
            this.$set(this.properties, 'fontJustify', data);
            break;
          case 'bold':
            this.$set(this.properties, 'fontWeight', ((this.properties['fontWeight'] == 'normal') ? 'bold' : 'normal'));
            break;
          case 'border':
            this.$set(this.properties, 'border', this.properties['border'] ? false : true);
            break;
          case 'wrap':
            this.$set(this.properties, 'fontOverflow', this.properties['fontOverflow'] ? false : true);
            break;
        }
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
      getFocusState: { deep: true, handler(h) { this.textAreaBtn('focus', h); } },
      // getSelectedState: { deep: true, handler(h) { this.textAreaBtn('focus', h); } },
    },
  };
</script>

<style scoped>
  /* -- Controls CSS -- */
  body button {
    width: 30px;
    height: 30px;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #444f;
    border-radius: 0px;
  }
  
  body button:hover {
    background-color: #555f;
  }
  
  body button:focus {
    border: none;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body button svg {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    fill: #0000;
    stroke: #ffff;
    stroke-width: 12px;
    pointer-events: none;
  }

  body button.selected {
    border: solid 1px #aaaf;
  }

  body button.selected svg {
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }

  body input {
    width: 100%;
    height: 30px;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body input:hover {
    border: solid 1px #0004;
  }
  
  body input:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body input:disabled {
    background-color: #dddf;
  }
  
  body select {
    width: 100%;
    height: 30px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body select:hover {
    border: solid 1px #0004;
  }
  
  body select:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  
  ::-moz-selection { /* Code for Firefox */
    color: #0000;
    background: #888f;
  }

  ::selection {
    color: #0000;
    background: #888f;
  }

  .textArea {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    padding: 0px;
    color: #000;
    -webkit-text-fill-color: transparent;
    background-color: #0000;
    border: none;
    outline: none;
    resize: none; 
    white-space: pre-wrap;
  }

  .textArea:focus {
    border: none;
    outline: none;
  }

  .editorMain {
    width: 200px;
    height: 75px;
    padding: 5px;
    position: absolute;
    bottom: -89px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #444f;
    z-index: 20;
  }

  .editorMain > .row {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .editorMain > .row > .column {
    width: auto;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .subEditorMain {
    width: 40px;
    height: 40px;
    padding: 5px;
    position: absolute;
    bottom: 0px;
    left: -53px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #444f;
    z-index: 20;
  }
</style>